import { useCallback, useEffect, useMemo, useState } from "react";
import {
  CHECKLIST_SECTIONS,
  CHECKLIST_VERSION,
  TOTAL_CHECKLIST_ITEMS,
} from "../data/checklistData";

const STORAGE_KEY = `myrep_predeploy_checklist_${CHECKLIST_VERSION}`;

const loadChecked = (): Record<string, boolean> => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed?.checked || {};
  } catch {
    return {};
  }
};

export const useChecklistProgress = () => {
  const [checked, setChecked] = useState<Record<string, boolean>>(loadChecked);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ checked }));
  }, [checked]);

  const toggleItem = useCallback((itemId: string) => {
    setChecked((prev) => ({ ...prev, [itemId]: !prev[itemId] }));
  }, []);

  const resetAll = useCallback(() => {
    setChecked({});
  }, []);

  const checkedCount = useMemo(
    () => Object.values(checked).filter(Boolean).length,
    [checked],
  );

  return {
    checked,
    toggleItem,
    resetAll,
    checkedCount,
    totalItems: TOTAL_CHECKLIST_ITEMS,
    sections: CHECKLIST_SECTIONS,
  };
};
